import Constants from "expo-constants";

const isDev = Constants.expoConfig?.extra?.towerPaymentsDev;

export const DEV_GRAPHQL_ENDPOINT =
  Constants.expoConfig?.extra?.towerPaymentsDevUrl;

export const PROD_GRAPHQL_ENDPOINT =
  Constants.expoConfig?.extra?.towerPaymentsProdUrl;

export const TOWER_PAYMENTS_GRAPHQL_ENDPOINT = isDev
  ? DEV_GRAPHQL_ENDPOINT
  : PROD_GRAPHQL_ENDPOINT;
